import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  getAllInstituteJobs,
  searchInstituteJobs,
} from "../../../APIs/GetAPIs";
import {
  updateInstituteContactDetails,
  updateProfileNew,
  getAllInstituteJobsPost,
} from "../../../APIs/PostAPIS";
import { Images } from "../../../Assets/0a-exporter";
import Notification from "../../Portals/Notification/Notification";
import JobPostedCard from "../CreateJobPostsModalCard/JobPostedCard";
import "./newJobModal.scss";

export default function CreateNewJObModal({ data, updateIt, closeIt }) {
  const [JobsList, setJobList] = React.useState([]);
  const [jobParams, setJobParams] = useState({
    job_status: "",
    search: "",
    pageNo: 0,
    pageSize: 20,
    sort: {
      job_title: 0,
    },
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      // let res = await getAllInstituteJobs();
      let res = await getAllInstituteJobsPost(jobParams);
      setJobList(res?.data?.data?.jobData);
    } catch (err) {
      console.log(err.response);
    }
  };
  const handleSearchInstituteJobs = async (title) => {
    if (title) {
      try {
        let res = await searchInstituteJobs(title);
        setJobList(res?.data?.data);
      } catch {
        console.log("errr");
      }
    } else {
      loadData();
    }
  };
  return (
    <div onClick={() => closeIt()} className="update-contact-details">
      <div className="ucd-modal create-job-modal">
        <header className="modal-ucd-m-header">
          <h5 className="create-modal-job-title">Create Job Post</h5>
          <p className="create-job-institute-name">
            Choose from the list to create similar post
          </p>
          <p className="create-job-institute-name create-job-institute-second-name">
            or <Link to="/institute/job/createjobpost">create new post</Link>
          </p>
          <header className="modal-jplml-header">
            <div className="jplm-modal-job-search">
              <img src={Images.graySearch} />
              <input
                placeholder="Search Job title"
                onChange={(event) =>
                  handleSearchInstituteJobs(event.target.value)
                }
              />
            </div>
          </header>
        </header>
        <div className="jplml-list-wrapper modal-jplml-list-wrapper">
          {JobsList.length !== 0 &&
            JobsList.map((job) => (
              <div className="jplmll-card-wrapper">
                <JobPostedCard job={job} />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
